import { esc } from '../escape.js';

// Navbar notification bell: draft Purchase Orders / pending shift corrections /
// pending leave requests, all three gated by the controller on the signed-in
// account's actual capabilities (not the switchable cashier - see controller.js
// _refreshNotifications). This view only renders what it's handed; it never
// checks permissions itself.

const fmtRelDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  const days = Math.floor((Date.now() - d) / 86400000);
  if (days <= 0) return 'Today';
  if (days === 1) return 'Yesterday';
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

const fmtPoNumber = (n) => `PO-${String(n ?? 0).padStart(3, '0')}`;

class NotificationView {
  _control  = document.getElementById('notifControl');
  _toggle   = document.getElementById('notifToggle');
  _dropdown = document.getElementById('notifDropdown');
  _list     = document.getElementById('notifList');
  _badge    = document.getElementById('notifBadge');

  _categoryClickHandler = null;
  _itemClickHandler     = null;

  _addHandlerCategoryClick(handler) { this._categoryClickHandler = handler; }
  _addHandlerItemClick(handler)     { this._itemClickHandler = handler; }

  reveal() {
    this._control?.classList.remove('hidden');
  }

  // { pos, corrections, leave }, { canPOs, canPay }
  render({ pos = [], corrections = [], leave = [] } = {}, { canPOs = false, canPay = false } = {}) {
    if (!this._list || !this._badge) return;

    const sections = [];
    if (canPOs) sections.push(this._section('po', '📝', 'Purchase orders', pos, (po) =>
      `<span class="notif-item-title">${esc(fmtPoNumber(po.poNumber))}</span><span class="notif-item-sub">${esc(po.supplierName || 'No supplier')}</span>`));
    if (canPay) sections.push(this._section('corrections', '⏱️', 'Shift corrections', corrections, (r) =>
      `<span class="notif-item-title">${esc(r.staffName || 'Staff')}</span><span class="notif-item-sub">${r.shiftId ? 'Correction' : 'Missed shift'} · ${esc(fmtRelDate(r.createdAt))}</span>`));
    if (canPay) sections.push(this._section('leave', '📅', 'Leave requests', leave, (r) =>
      `<span class="notif-item-title">${esc(r.staffName || 'Staff')}</span><span class="notif-item-sub">${r.type === 'sick' ? '🤒 Sick' : '✈️ Vacation'} · ${esc(fmtRelDate(r.createdAt))}</span>`));

    const total = sections.reduce((s, sec) => s + sec.count, 0);
    this._list.innerHTML = sections.length
      ? sections.map((sec) => sec.html).join('')
      : `<div class="notif-empty">You're all caught up 🎉</div>`;

    if (total > 0) {
      this._badge.textContent = total > 99 ? '99+' : String(total);
      this._badge.classList.remove('hidden');
    } else {
      this._badge.classList.add('hidden');
    }
  }

  _section(cat, icon, label, rows, rowHtml) {
    const html = `
      <div class="notif-section">
        <button class="notif-section-head" data-cat="${cat}" type="button">
          <span class="notif-section-icon" aria-hidden="true">${icon}</span>
          <span class="notif-section-label">${label}</span>
          <span class="notif-section-count">${rows.length}</span>
        </button>
        ${rows.length ? `<div class="notif-section-items">
          ${rows.slice(0, 5).map((r) => `
            <button class="notif-item" data-cat="${cat}" data-id="${esc(r.id)}" type="button">
              ${rowHtml(r)}
            </button>`).join('')}
          ${rows.length > 5 ? `<button class="notif-item notif-item--more" data-cat="${cat}" type="button">+${rows.length - 5} more</button>` : ''}
        </div>` : `<p class="notif-section-empty">None pending</p>`}
      </div>`;
    return { count: rows.length, html };
  }

  _addHandlerDropdownClicks() {
    this._list?.addEventListener('click', (e) => {
      const itemBtn = e.target.closest('.notif-item');
      const headBtn = e.target.closest('.notif-section-head');
      if (itemBtn) {
        const { cat, id } = itemBtn.dataset;
        if (id) this._itemClickHandler?.(cat, id);
        else this._categoryClickHandler?.(cat); // "+N more" row
      } else if (headBtn) {
        this._categoryClickHandler?.(headBtn.dataset.cat);
      }
    });
  }
}

const _view = new NotificationView();
_view._addHandlerDropdownClicks();
export default _view;
